import { render } from "./DetailSiswa.vue?vue&type=template&id=4a8acab0"
import script from "./DetailSiswa.vue?vue&type=script&lang=js"
export * from "./DetailSiswa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__